
import React from 'react';
import { Link } from 'react-router-dom';

const BusinessLinks: React.FC = () => {
  // Intentionally left empty as the user requested removal of the reseller platform link
  return null;
};

export default BusinessLinks;
